import { render } from "./ModalKyc.vue?vue&type=template&id=4dad40f1&scoped=true&ts=true"
import script from "./ModalKyc.vue?vue&type=script&lang=ts"
export * from "./ModalKyc.vue?vue&type=script&lang=ts"

import "./ModalKyc.vue?vue&type=style&index=0&id=4dad40f1&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dad40f1"]])

export default __exports__